import { Link, useLocation } from 'react-router-dom';

import { getProjectPage } from '@/content/projectPages';

export default function ProjectDetailPage() {
  const { pathname } = useLocation();
  const project = getProjectPage(pathname);

  if (!project) return null;

  const photos = project.photos ?? [];
  return (
    <article className="min-h-screen bg-cream-50">
      <header className="pt-32 md:pt-40 pb-14 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <p className="font-mono text-xs text-terracotta-600 tracking-[0.25em] uppercase mb-5">{project.category} · {project.suburb}</p>
          <h1 className="font-serif text-5xl md:text-7xl text-charcoal-900 leading-[0.95]">{project.name}</h1>
        </div>
        <div className="lg:col-span-4">
          <p className="text-terracotta-700 font-medium mb-4">{project.credential}</p>
          <div className="flex flex-wrap gap-2">{project.tags.map((tag) => <span key={tag} className="px-3 py-1 bg-stone-100 text-xs text-stone-600">{tag}</span>)}</div>
        </div>
      </header>

      {photos[0] && <img src={photos[0]} alt={`${project.name} exterior`} width="1600" height="1000" fetchPriority="high" decoding="async" className="w-full max-h-[76vh] object-cover" />}

      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-3"><p className="font-mono text-xs text-stone-400 tracking-[0.22em] uppercase">Project story</p></div>
        <div className="md:col-span-9"><p className="font-serif text-2xl md:text-3xl text-charcoal-800 leading-relaxed">{project.description}</p></div>
      </div>

      {photos.length > 1 && (
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pb-24 grid grid-cols-1 md:grid-cols-2 gap-5">
          {photos.slice(1).map((photo, index) => <img key={photo} src={photo} alt={`${project.name} view ${index + 2}`} width="1200" height="900" loading="lazy" decoding="async" className="w-full aspect-[4/3] object-cover" />)}
        </div>
      )}

      <div className="bg-stone-100 py-16"><div className="max-w-[1200px] mx-auto px-6 md:px-12 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center"><Link to="/portfolio" className="text-charcoal-800 hover:text-terracotta-600">← Back to portfolio</Link><Link to="/contact" className="px-7 py-3 bg-charcoal-900 text-cream-50 hover:bg-charcoal-800">Discuss a similar project</Link></div></div>
    </article>
  );
}
